export const ARTICLE_BLOG_LIST = '/article/blog';
export const ARTICLE_COOP_LIST = '/article/cooperatives';

export function articleBlogPostPath(slug) {
  return `/article/b/${slug}`;
}

export function articleCoopPath(slug) {
  return `/article/c/${slug}`;
}
